import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import "./i18n";
import AppHelmet from "./components/helmet";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import MaintenancePage from "./components/maintenancePage";

const isMaintenanceMode = false; // Set this to true to enable maintenance mode, false to disable it

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  isMaintenanceMode ? (
    <MaintenancePage />
  ) : (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <React.StrictMode> */}
        <AppHelmet />
        <App />
        {/* </React.StrictMode> */}
      </PersistGate>
    </Provider>
  )
);
